import React from 'react';
import { StyledTableRowColumn } from '../../table/StyledTable';
import { Currency } from 'ui-toolkit';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { StyledSelectedIcon, StyledTableRow } from './MatchedActualStyles';
import { IEscrowActualIncomingAchData } from 'types/accounting/data/IEscrowActualIncomingAchData';
import { getDateString } from '../../../../../ui-toolkit/utilities/getDateString';

interface IMatchActualACHDepositRowProps {
  achDeposit: IEscrowActualIncomingAchData;
  selectedId?: string;
  setSelectedId: (detail: string | undefined) => void;
}

export const MatchActualACHDepositRow: React.FC<IMatchActualACHDepositRowProps> = ({
  achDeposit,
  selectedId,
  setSelectedId,
}) => {
  return (
    <>
      <StyledTableRow
        columnsLength={5}
        onClick={() => {
          selectedId === achDeposit.id ? setSelectedId(undefined) : setSelectedId(achDeposit.id);
        }}
        data-test-id={'actual-ach-deposit-row'}
      >
        <StyledTableRowColumn>{getDateString(`LLLL d, yyyy`, achDeposit.createdAt)}</StyledTableRowColumn>
        <StyledTableRowColumn>{achDeposit.wellsFargoTransactionNumber}</StyledTableRowColumn>
        <StyledTableRowColumn>{achDeposit.source}</StyledTableRowColumn>
        <StyledTableRowColumn>
          <Currency value={achDeposit.amountCents} valueIsCents />
        </StyledTableRowColumn>
        <StyledTableRowColumn>
          {selectedId === achDeposit.id && (
            <StyledSelectedIcon icon={faCircleCheck} size={'lg'} aria-label={'selectedrow'} />
          )}
        </StyledTableRowColumn>
      </StyledTableRow>
    </>
  );
};
